module.exports = __webpack_public_path__ + "img/2025_L.9d34a48f.png";